import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Routes } from '@emi/shared/constants';
import { SearchOption } from '@emi/shared/models';
import { DataExtractionState } from '@emi/shared/state/filters';
import { getSkuSearchResults, selectOrderByRLP, selectSkuSearchState, selectSortByRLP, SortOptionsByPageState } from '@emi/shared/state/sku-search';
import { Store, select } from '@ngrx/store';
import { take } from 'rxjs/operators';

@Component({
    selector: 'via-sku-time-series-top-bar',
    templateUrl: './sku-time-series-top-bar.component.html',
    styleUrls: ['./sku-time-series-top-bar.component.scss'],
})
export class SkuTimeSeriesTopBarComponent {
    public searchTerm: string;
    public searchOption: SearchOption;
    public includeSearchPhrase: boolean | undefined;
    public resultsPageSortType: string | undefined;
    public resultsPageOrderType: string | undefined;

    constructor(private router: Router, 
        private readonly store: Store<DataExtractionState>, 
        private searchStore: Store, 
        private readonly sortOptionsByPageStore: Store<SortOptionsByPageState> ) { }

    public backClicked(): void {
        this.store.pipe(select(selectSkuSearchState), take(1)).subscribe((state) => {
            this.searchTerm = state.searchTerm;
            this.searchOption = state.searchOption;
            this.includeSearchPhrase = state.includeSearchPhrase;
        });

        this.sortOptionsByPageStore.pipe(select(selectSortByRLP), take(1)).subscribe((sortBy) => {
            this.resultsPageSortType = sortBy;
        });

        this.sortOptionsByPageStore.pipe(select(selectOrderByRLP), take(1)).subscribe((orderBy) => {
            this.resultsPageOrderType = orderBy;
        });

        this.searchStore.dispatch(
            getSkuSearchResults({
                searchTerm: this.searchTerm,
                searchOption: this.searchOption,
                sortBy: this.resultsPageSortType,
                orderBy: this.resultsPageOrderType,
                includeSearchPhrase: this.includeSearchPhrase
            })
        );

        this.router.navigate([Routes.SKU_SEARCH_RESULTS]);
    }
}
